import { ApplicationContext } from './context/application.context';
import { Injectable } from './dependency-injection/decorators';

@Injectable()
export class BrowserObjectModel {
  constructor (private readonly applicationContext: ApplicationContext) {
  }

  getWindow (): Window {
    return this.applicationContext.getWindow();
  }

  getDocument (): Window['document'] {
    return this.getWindow().document;
  }
}
